import { AutoFocusModule } from 'primeng/autofocus';
import { Component } from '@angular/core';
import { FieldBase } from './field-base';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { ReactiveFormsModule } from '@angular/forms';
import { SafeHtmlPipe } from '../../pipe/safe-html.pipe';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'field-textbox',
    imports: [
        AutoFocusModule,
        IconFieldModule,
        InputIconModule,
        InputTextModule,
        ReactiveFormsModule,
        SafeHtmlPipe,
        TooltipModule
    ],
    template: `
        <div [formGroup]="form()">
            <label
                class="text-base ellipsis-label {{labelClass}}"
                for="{{key}}"
                pTooltip="{{label}}"
                [fitContent]="false"
            >
                <div class="flex flex-row justify-content-between">
                    <div class="{{labelClass}}">
                        {{label}}
                        @if ( required ) {
                            <span class="text-red-600">*</span>
                        }
                    </div>
                    @if ( maxLength > 0 ) {
                        <span class="text-sm text-500">Máx: {{maxLength}} </span>
                    }
                </div>
            </label>
            @if ( icon ) {
                <p-iconField class="w-full">
                    <p-inputIcon styleClass="{{icon}}" />
                    <input
                        #field
                        [pAutoFocus]="setFocus()"
                        (keydown.enter)="onNext($event)"
                        id="{{key}}"
                        class="text-base text-color surface-overlay p-2 pl-6 border-1 border-solid surface-border focus:border-primary w-full"
                        formControlName="{{key}}"
                        pInputText
                        [type]="type || 'text'"
                        [attr.aria-describedby]="isInvalid || fieldError.trim().length > 0 ? key + '-error' : null"
                        [attr.aria-invalid]="isInvalid || fieldError.trim().length > 0"
                        [attr.autocomplete]="autocomplete || 'off'"
                        [attr.inputmode]="inputMode || null"
                        [attr.autocapitalize]="autoCapitalize || null"
                        [attr.autocorrect]="autoCorrect || null"
                        [attr.placeholder]="placeholder || null"
                        showDelay="500"
                        pTooltip="{{tip || label}}"
                        tooltipPosition="bottom"
                        [fitContent]="false"
                        [attr.maxlength]="maxLengthAttr"
                    />
                </p-iconField>
            } @else {
                <input
                    #field
                    [pAutoFocus]="setFocus()"
                    (keydown.enter)="onNext($event)"
                    id="{{key}}"
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border focus:border-primary w-full"
                    formControlName="{{key}}"
                    pInputText
                    [type]="type || 'text'"
                    [attr.aria-describedby]="isInvalid || fieldError.trim().length > 0 ? key + '-error' : null"
                    [attr.aria-invalid]="isInvalid || fieldError.trim().length > 0"
                    [attr.autocomplete]="autocomplete || 'off'"
                    [attr.inputmode]="inputMode || null"
                    [attr.autocapitalize]="autoCapitalize || null"
                    [attr.autocorrect]="autoCorrect || null"
                    [attr.placeholder]="placeholder || null"
                    showDelay="500"
                    pTooltip="{{tip || label}}"
                    tooltipPosition="bottom"
                    [fitContent]="false"
                    [attr.maxlength]="maxLengthAttr"
                />
            }
            <small id="{{key}}-error" class="text-red-600 block mt-1" style="min-height: 1.1rem;" aria-live="polite" [innerHtml]="fieldError | safeHtml"></small>
        </div>
    `
})
export class FieldTextBox extends FieldBase<string> {
    override type!: string

    constructor() {
        super()
        this.controlType = 'textbox'
    }
}
